import styled from 'styled-components';
import breakpoint from 'theme/breakpoint';

export default styled('div')`
  position: relative;
  display: flex;
  flex: 0 1 100%;
  flex-direction: column;
  overflow: hidden;
  box-sizing: border-box;
  width: 100%;
  padding: 0 ${props => props.theme.paddingSM};
  margin: 0 auto;
  background-color: ${props => props.theme.contentBackground};

  ${breakpoint.up('s')`
    max-width: ${props => props.theme.breakpoints.s}px;
    padding: 0 ${props => props.theme.paddingL};
  `}
`
